import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetInitialStateFacade } from '../../../../../common/models';
import { TransportManagementSearchCriteria } from '../models/transport-management.model';
import { TransportManagementLoadFetch, TransportManagementLoadInitialState } from './transport-management-load.actions';
import { TransportManagementLoadState, TransportManagementLoadStateModel } from './transport-management-load.state';
import { Observable } from 'rxjs';
import { TransportManagementTileItem } from '../models';

@Injectable({ providedIn: 'root' })
export class TransportManagementLoadFacade implements SetInitialStateFacade {
  listDto$: Observable<TransportManagementLoadStateModel> = this.store.select(TransportManagementLoadState.getState);
  items$: Observable<TransportManagementTileItem[]> = this.store.select(TransportManagementLoadState.getItems);
  loaded$: Observable<boolean> = this.store.select(TransportManagementLoadState.getLoaded);
  isMoreButtonVisible$: Observable<boolean> = this.store.select(TransportManagementLoadState.isMoreButtonVisible);
  isReportLimitationExceeded$: Observable<boolean> = this.store.select(
    TransportManagementLoadState.isReportLimitationExceeded,
  );

  constructor(private store: Store) {}

  load(searchCriteria: TransportManagementSearchCriteria): void {
    this.store.dispatch(new TransportManagementLoadFetch(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportManagementLoadInitialState());
  }
}
